"use strict";

var child = require("child_process");

var runner = function runner(options, callback) {
  var runner = child.fork(__dirname + "/sandbox.js"); //send sandbox the code

  runner.send(options); //handle sandbox output

  runner.on("message", function (message) {
    clearTimeout(timer);
    callback(message);
  });
  var timer = setTimeout(function () {
    runner.kill();
    return callback({
      valid: false,
      message: "Took too long to run!",
      consoleOutput: "Error - timeout (5s)"
    });
  }, 5000);
};

module.exports = runner;